import Select from "react-select";

const SelectField = ({ name, value, onChange, options, disabled }) => {
  const selected = options?.find((o) => o.value === value);

  return (
    <Select
      isDisabled={disabled}
      options={options || []}
      value={selected || null}
      isSearchable
      menuPortalTarget={document.body}
      onChange={(option) => onChange(name, option?.value)}
      styles={{
        container: (base) => ({
          ...base,
          width: "150px",
          fontSize: "11px",
        }),

        control: (base) => ({
          ...base,
          minHeight: "28px",
          fontSize: "11px",
        }),

        valueContainer: (base) => ({
          ...base,
          fontSize: "11px",
          // padding: "0.8px",
        }),

        input: (base) => ({
          ...base,
          fontSize: "11px",
        }),

        singleValue: (base) => ({
          ...base,
          fontSize: "11px",
        }),

        placeholder: (base) => ({
          ...base,
          fontSize: "11px",
        }),

        option: (base) => ({
          ...base,
          fontSize: "11px",
        }),

        menuPortal: (base) => ({
          ...base,
          // zIndex: 9999,
        }),
      }}
    />
  );
};

export default SelectField;
